<template>
    <div class="maindiv">
        <Nav currentpath="/">
            <h1>About me</h1>

            <div class="infotile">
                <p>
                    I recently defended my Phd thesis in combinatorial optimization. I mainly work on efficient algorithms for hard combinatorial optimization problems (mostly tree search algorithms).
                </p>
                <p>
                    I am currently working on applying optimization techniques for differential cryptanalysis attacks.
                </p>
                <ul>
                    <li><i class="material-icons">place</i><b>Office:</b><span>LIMOS, Bâtiment ISIMA - Bureau F203</span></li>
                    <li><i class="material-icons">mail</i><b>Mail:</b><span><a class="withmargin" href="mailto:luc.libralesso@uca.fr">luc.libralesso@uca.fr</a></span></li>
                    <li><i class="material-icons">account_circle</i><span><a class="withmargin" href="https://www.researchgate.net/profile/Luc_Libralesso">ResearchGate</a></span></li>
                    <li><i class="material-icons">account_circle</i><span><a class="withmargin" href="https://www.linkedin.com/in/luc-libralesso/">Linkedin</a></span></li>
                    <li><i class="material-icons">account_circle</i><span><a class="withmargin" href="https://twitter.com/librallu/">Twitter</a></span></li>
                    <li><i class="material-icons">import_contacts</i><span><a class="withmargin" href="/pdfs/CV_libralesso.pdf">my CV</a></span></li>
                </ul>


                <h2>My phd thesis</h2>
                <ul class="ul-larger">
                    <li><a class="withmargin" href="/pdfs/these_final_libralesso.pdf">thesis (pdf)</a></li>
                    <li><a class="withmargin" href="/presentations/20_07_thesis_defense.pdf">slides (pdf)</a></li>
                </ul>

                <h3>abstract</h3>
                <p>
                Tree search algorithms are used in a large variety of applications (MIP, CP, SAT, metaheuristics with Ant Colony Optimization and GRASP) and also in AI/planning communities. All of these techniques present similar components and many of those components can be transferred from one community to another. Preliminary results indicate that anytime tree search (search techniques from AI/planning) can be part of the operations research toolbox as they are simple and competitive compared to commonly used metaheuristics in operations research.
                </p>
                <p>
                In this work, we detail a state of the art and a classification of the different tree search techniques that one can find in metaheuristics, exact methods, and AI/planning. Then, we present a generic framework that allows the rapid prototyping of tree search algorithms. Finally, we use this framework to develop anytime tree search algorithms that are competitive with the commonly-used metaheuristics in operations research. We report new tree search applications for some combinatorial optimization problems and new best-known solutions.
                </p>

                <h3>defense (in french)</h3>
                <div class="responsive-video">
                    <iframe width="750" height="422" src="https://www.youtube.com/embed/m2r5-ffmCFc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

            </div>

        </Nav>
    </div>
</template>

<script>
import Nav from "../../components/Nav.vue"

export default {
    name: 'Home',
    components: {Nav}
}
</script>

<style lang="scss">
.infotile {
    padding: 10px;

    ul {
        list-style-type: none;
        
        li {
            display: flex;
            align-content: center;
            i {
                padding: 5px;
            }
            b {
                padding: 5px;
            }
            span {
                padding: 5px;
            }
        }
    }
}

.withmargin {
    margin: 10px;
}

.responsive-video {
    overflow: hidden; 
    padding-bottom: 56.25%; 
    position: relative; 
    height: 0;

    iframe {
        left: 0; 
        top: 0; 
        height: 100%;
        width: 100%;
        position: absolute;
    }
}
</style>
